import { VenueCarouselItem } from "@punchup/data/models";

interface Props {
  item: Extract<VenueCarouselItem, { type: "video" }>;
}

export default function VideoCarouselItem({ item }: Props) {
  return (
    <div className="w-full">
      <div className="relative aspect-[16/9] rounded-lg overflow-hidden bg-gray-100 flex items-center justify-center">
        <span className="text-gray-400 text-sm">Video</span>
      </div>
    </div>
  );
}
